/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Reminders_AddInputs */

const en_task_reminders_add = /** @type {(inputs: Task_Reminders_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add reminder`)
};

const pt_br2_task_reminders_add = /** @type {(inputs: Task_Reminders_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar lembrete`)
};

/**
* | output |
* | --- |
* | "Add reminder" |
*
* @param {Task_Reminders_AddInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_reminders_add = /** @type {((inputs?: Task_Reminders_AddInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Reminders_AddInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_reminders_add(inputs)
	return pt_br2_task_reminders_add(inputs)
});